import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkStatsItem.module.css';

export function DevlinkStatsItem({
  as: _Component = _Builtin.Block,
  showGraphic = true,
  graphicSource = '',
  prominentText = '1,000',
  subtext = 'Subtext',
}) {
  return (
    <_Component className={_utils.cx(_styles, 'ht-stats-item')} tag="div">
      <_Builtin.Block className={_utils.cx(_styles, 'ht-stats-prominent-row')} tag="div">
        {showGraphic ? (
          <_Builtin.Image className={_utils.cx(_styles, 'image-56')} loading="lazy" width="auto" height="auto" alt="" src={graphicSource} />
        ) : null}
        <_Builtin.Block className={_utils.cx(_styles, 'ht-stats-prominent-value')} tag="div" comma="on">
          {prominentText}
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, 'tiny')} tag="div" />
      <_Builtin.Block className={_utils.cx(_styles, 'ht-stats-subtext')} tag="div">
        <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>{subtext}</_Builtin.Paragraph>
      </_Builtin.Block>
    </_Component>
  );
}
